<template>
  <div id="SucceedDetails">
      111
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>